import _pick from 'lodash/pick';
import routeNames from '../router/route-names';

export const LOGIN_THEME = 'novated';
export const GLOBAL_ERROR = 'GLOBAL_ERROR';

export const GQL_ERROR_CODES = {
  notFound: 'NOT_FOUND',
  forbidden: 'FORBIDDEN',
};

export const HOME_ROUTE = routeNames.calculator;

export const QUOTE_REQUESTED_PATH = 'images/quote-requested-circle.svg';
export const HR_APPROVAL_SENT_PATH = 'images/message-sent.svg';
export const PROFILE_SETUP_CONTACT_PATH = 'images/profile-setup-contact.svg';
export const PROFILE_SETUP_POSTCODE_PATH = 'images/profile-setup-postcode.svg';
export const PROFILE_SETUP_WORKTYPE_PATH = 'images/profile-setup-worktype.svg';

export const SALE_TAG_PATH = 'icons/sale-tag.svg';

export const DEFAULT_BRAND = 'fleetPlus';
export const BRAND_DOCUMENTS = {
  fleetPlus: {
    disclosureAndConsent: 'documents/FPartners-disclosure-and-consent.pdf',
    leaseTerms: 'documents/FPartners-lease.pdf',
  },
  fleetPartners: {
    disclosureAndConsent: 'documents/FPartners-disclosure-and-consent.pdf',
    leaseTerms: 'documents/FPartners-lease.pdf',
  },
  fleetChoice: {
    disclosureAndConsent: 'documents/FPartners-disclosure-and-consent.pdf',
    leaseTerms: 'documents/FPartners-lease.pdf',
  },
};

export const ROUTE_VALIDATION_ORDER = [
  routeNames.calculator,
  routeNames.budget,
  routeNames.carSearch,
  routeNames.carSearchVariant,
  routeNames.quoteUpload,
  routeNames.carColourAndExtras,
  routeNames.dealerPrice,
  routeNames.summary,
  routeNames.hrApproval,
  routeNames.hrApprovalSent,
  routeNames.vehicleOrdered,
  routeNames.redirection,
];

// Paths that will be sent with an application save against the key
export const APPLICATION_UPDATE_PATHS = {
  [routeNames.quoteUpload]: [
    'metaData.quoteUpload',
    'metaData.customerOptions',
  ],
  [routeNames.calculator]: ['metaData.customerOptions'],
  [routeNames.budget]: ['metaData.costsWeekly'],
  [routeNames.carColourAndExtras]: ['metaData.customerOptions'],
  [routeNames.carSearch]: ['metaData.customerOptions'],
  [routeNames.carSearchVariant]: ['metaData.customerOptions'],
  [routeNames.dealerPrice]: ['metaData.customerOptions'],
};

export const ROUTES_REQUIRING_COMPLETED_FORMS = _pick(
  APPLICATION_UPDATE_PATHS,
  [
    routeNames.carColourAndExtras,
    routeNames.carSearch,
    routeNames.carSearchVariant,
  ]
);

export const APPLICATION_STATUSES = {
  draft: 'draft',
  complete: 'complete',
  delete: 'delete',
};

export const QUOTE_STATUSES = {
  DRAFT: {
    value: 'DRAFT',
    label: 'Draft',
  },
  SUBMITTED: {
    value: 'SUBMITTED',
    label: 'Submitted',
  },
  REQUESTED: {
    value: 'requested',
    label: 'Requested',
  },
  AWAITINGPRICING: {
    value: 'AWAITINGPRICING',
    label: 'Awaiting Quote',
  },
  PRICINGRECEIVED: {
    value: 'PRICINGRECEIVED',
    label: 'Pending Acceptance',
  },
  ACCEPTED: {
    value: 'ACCEPTED',
    label: 'Accepted',
  },
  CANCELLED: {
    value: 'CANCELLED',
    label: 'Cancelled',
  },
};

export const DEFAULT_QUOTE_STATUS_COLOUR = 'positive';
export const QUOTE_STATUS_COLORS = {
  [QUOTE_STATUSES.REQUESTED.value]: 'champagne',
  [QUOTE_STATUSES.SUBMITTED.value]: 'champagne',
  [QUOTE_STATUSES.AWAITINGPRICING.value]: 'champagne',
  [QUOTE_STATUSES.PRICINGRECEIVED.value]: 'positive',
  [QUOTE_STATUSES.ACCEPTED.value]: 'application-primary',
};

export const UPLOAD_QUOTE_COMPLETE_STATUSES = {
  happyWithQuote: 'customerHappyWithCurrentQuote',
  requestBetterQuote: 'customerRequestBetterQuote',
};

export const EMPLOYMENT_OPTIONS = {
  fullTime: { label: 'Full Time', value: 'fullTime' },
  partTime: { label: 'Part Time', value: 'partTime' },
  contactTemp: { label: 'Contract/Temp', value: 'contactTemp' },
  other: { label: 'Other', value: 'other' },
};

export const USER_PROFILE_PAGES = {
  employerDetails: 'employerDetails',
  organisationSelection: 'organisationSelection',
  employmentType: 'employmentType',
  postcode: 'postCode',
  contactNumber: 'contactNumber',
};

export const MATCHES_ORGANISATIONS_OPTIONS = {
  single: 'single',
  multiple: 'multiple',
  none: 'none',
};

export const CAR_SELECTION_ROUTES = [
  routeNames.carSearch,
  routeNames.carSearchVariant,
  routeNames.quoteUpload,
  routeNames.carColourAndExtras,
  routeNames.dealerPrice,
  routeNames.summary,
];
export const FINANCE_ROUTES = [routeNames.calculator, routeNames.budget];
export const HR_ROUTES = [routeNames.hrApproval, routeNames.hrApprovalSent];

export const ROUTE_BASE = '/quotes';

export const USER_ACCESS_LEVEL = {
  APPLICATION: 'APPLICATION', // User has full basic access
  DASHBOARD: 'DASHBOARD', // User should only have access to the dashboard
  NONE: 'NONE', // User should not go further than the calculator
  CREDIT_ONLY: 'CREDIT_ONLY', // User should have NO access
};

export const INITIAL_LEAD = {
  annualSalary: undefined,
  vehicleCondition: '',
  bodyType: '',
  carValue: undefined,
  leaseTerm: undefined,
};

export const INITIAL_USER = {
  profile: {
    companyName: undefined,
    companyEmail: undefined,
    employmentType: undefined,
    postcode: undefined,
    contactNumber: undefined,
    noCorporateEmail: false,
    corporateEmailVerified: false,
    matchesOrganisations: undefined,
  },
  contactDetails: {},
  hasOrganisation: false,
  matchesMultiOrganisations: false,
  entity: undefined,
  permissions: [],
  features: {},
  accessLevel: undefined,
};

export const INITIAL_MAKE = {
  id: undefined,
  name: undefined,
  description: undefined,
};

export const INITIAL_MODEL = {
  id: undefined,
  name: undefined,
};

export const INITIAL_CUSTOMER = {
  companyName: undefined,
  companyAbn: undefined,
  customerName: undefined,
  customerContactEmail: undefined,
  customerContactNumber: undefined,
  deliveryAddressLine1: undefined,
  deliveryAddressLine2: undefined,
  deliverySuburb: undefined,
  deliveryState: undefined,
  deliveryPostcode: undefined,
  deliveryDate: undefined,
  dealership: undefined,
  registrationPostcode: undefined,
};

export const INITIAL_PRICE = {
  onRoadCost: undefined,
  fbtValue: undefined,
  listPrice: undefined,
  listPriceNet: undefined,
  listPriceGst: undefined,
  listPriceGross: undefined,
  monthlyRentalNet: undefined,
  monthlyRentalGst: undefined,
  monthlyRentalGross: undefined,
  weeklyRentalNet: undefined,
};

export const BUSINESS_USE_ACKNOWLEDGMENT_VALUE = 51;

export const LEASE_TERM_OPTIONS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
];

export const ANNUAL_SALARY_MIN = 0;
export const ANNUAL_SALARY_MAX = 300000;
export const CAR_VALUE_MIN = 10000;
export const CAR_VALUE_MAX = 170000;
export const KMS_PER_YEAR_MAX = {
  1: 200000,
  2: 100000,
  3: 65000,
  4: 50000,
  5: 40000,
};
export const KMS_PER_YEAR_STEP = {
  1: 10000,
  2: 10000,
  3: 5000,
  4: 5000,
  5: 2000,
};
export const KMS_PER_YEAR_LABELS = {
  1: ['10k', '50k', '80k', '120k', '160k', '200k+'],
  2: ['10k', '30k', '50k', '60k', '80k', '100k+'],
  3: ['10k', '20k', '30k', '45k', '55k', '65k+'],
  4: ['5k', '15k', '25k', '30k', '40k', '50k+'],
  5: ['4k', '12k', '18k', '26k', '32k', '40k+'],
};
export const KMS_PER_YEAR_MIN = {
  1: 10000,
  2: 10000,
  3: 10000,
  4: 5000,
  5: 4000,
};
export const CALCULATION_FREQUENCIES = {
  weekly: {
    label: 'Week',
    adverbLabel: 'Weekly',
    value: 'weekly',
    type: 'week',
    weeksIn: 1,
  },
  fortnightly: {
    label: 'Fortnight',
    adverbLabel: 'Fortnightly',
    value: 'fortnightly',
    type: 'fortnight',
    weeksIn: 2,
  },
  monthly: {
    label: 'Month',
    adverbLabel: 'Monthly',
    value: 'monthly',
    type: 'month',
    weeksIn: 52 / 12,
  },
  yearly: {
    label: 'Year',
    adverbLabel: 'Yearly',
    value: 'yearly',
    type: 'year',
    weeksIn: 52,
  },
};
export const BUDGET_PAY_COMPARISON_TYPES = {
  payment: {
    label: 'Payment',
    value: 'payment',
  },
  takeHomePay: {
    label: 'Estimated Take Home Pay',
    value: 'takeHomePay',
  },
};
export const BUDGET_LEASE_COMPARISON_TYPES = {
  salarySacrifice: {
    label: 'Novated Lease',
    value: 'salarySacrifice',
    imgPath: 'icons/novated-inactive.svg',
    activeImgPath: 'icons/novated-active.svg',
  },
  notSalarySacrifice: {
    label: 'Car Loan',
    value: 'notSalarySacrifice',
    imgPath: 'icons/not-novated-inactive.svg',
    activeImgPath: 'icons/not-novated-active.svg',
  },
};

export const INITIAL_COLOURS_AND_EXTRAS = {
  exteriorColours: [],
  interiorColours: [],
  includedEquipment: [],
  optionalEquipment: [],
};

export const INITIAL_QUOTE = {
  quoteId: undefined,
  erpQuoteRef: undefined,
  milesQuoteRef: undefined,
  status: QUOTE_STATUSES.DRAFT.value,
  product: {},
  make: { ...INITIAL_MAKE },
  bodyType: undefined,
  model: { ...INITIAL_MODEL },
  variant: {},
  isNew: true,
  availableOptions: {},
  leaseTerm: undefined,
  kmsPerYear: 0,
  leaseStart: undefined,
  leaseEnd: undefined,
  leaseOptions: [],
  exteriorColour: undefined,
  interiorColour: undefined,
  includedEquipment: [],
  optionalEquipment: [],
  adhocEquipment: [],
  customer: { ...INITIAL_CUSTOMER },
  price: { ...INITIAL_PRICE },
};

export const NEW_USED_LIST = {
  new: {
    label: 'New',
    value: 'new',
  },
  used: {
    label: 'Used',
    value: 'used',
  },
};
export const NEW_YEAR_FUTURE = 2;
export const USED_YEAR_PAST = 11;

export const INITIAL_CAR_SEARCH = {
  newUsed: NEW_USED_LIST.new.value,
  makeId: undefined,
  bodyType: undefined,
  modelId: undefined,
  transmission: undefined,
  year: undefined,
};

export const FINANCE_BUDGET_PAYLOAD = {
  price: 0,
  registeredState: 'NSW',
  kmsPerYear: 10000,
  leaseTerm: 24,
  customer: { annualSalary: 90000, registrationPostcode: '2020' },
};

export const MAXIMUM_ADHOC_VEHICLE_OPTIONS = 20;

export const VEHICLE_TYPES = {
  SM: {
    name: 'Small',
    icon: 'icon-body-small',
  },
  MS: {
    name: 'Mid-Size',
    icon: 'icon-body-mid-size',
  },
  LR: {
    name: 'Large',
    icon: 'icon-body-large',
  },
  SV: {
    name: 'SUV',
    icon: 'icon-body-suv',
  },
  L4: {
    name: 'Large 4WD',
    icon: 'icon-body-large-4wd',
  },
  LX: {
    name: 'Luxury',
    icon: 'icon-body-luxury',
  },
  SP: {
    name: 'Sports',
    icon: 'icon-body-sports',
  },
};

export const UPLOAD_QUOTE_TYPES = {
  dealer: 'dealer',
};

export const CAR_IS_FROM_OPTIONS = {
  private: {
    value: 'private',
    label: 'Private Sale',
  },
  individual: {
    value: 'own',
    label: 'Own Vehicle',
  },
};

export const DEFAULT_CALCULATOR_CUSTOMER_OPTIONS = {
  annualSalary: 90000,
  carValue: 50000,
  vehicleCondition: NEW_USED_LIST.new.value,
  leaseTerm: 48,
  bodyType: 'Small',
  kmsPerYear: 10000,
  businessUse: 0,
};

export const DEFAULT_COST_WEEKLY = {
  fuel: undefined,
  maintenance: undefined,
  tyres: undefined,
  registration: undefined,
  insurance: undefined,
  accessories: undefined,
};

export const DEFAULT_CUSTOMER_OPTIONS = {
  ...DEFAULT_CALCULATOR_CUSTOMER_OPTIONS,
  variant: undefined,
  exteriorColour: undefined,
  interiorColour: undefined,
  optionalEquipment: undefined,
  odometer: undefined,
  carPrice: undefined,
  carIsFrom: undefined,
  registrationNumber: undefined,
};

const DEFAULT_QUOTE_UPLOAD = {
  quoteFile: undefined,
};

export const UPLOAD_QUOTE_MAX_FILE = 1;
export const UPLOAD_QUOTE_MAX_FILE_SIZE = 10000000;
export const UPLOAD_QUOTE_MAX_TOTAL_FILE_SIZE =
  UPLOAD_QUOTE_MAX_FILE_SIZE * UPLOAD_QUOTE_MAX_FILE;
export const UPLOAD_QUOTE_FILE_TYPES = 'image/png, image/jpeg, image/jpg, .pdf';
export const PROOF_HINT = 'We only accept PDF, PNG and JPEGS.';

export const INITIAL_APPLICATION = {
  applicationId: undefined,
  applicationType: undefined,
  applicationStatus: undefined,
  metaData: {
    quoteId: undefined,
    customerOptions: { ...DEFAULT_CUSTOMER_OPTIONS },
    costsWeekly: { ...DEFAULT_COST_WEEKLY },
    quoteUpload: {},
    hrApprovalRequestSent: false,
    creditCheckCompleted: false,
  },
};

export const DEFAULT_COLOUR_AND_EXTRA = {
  id: undefined,
  code: undefined,
  name: undefined,
};

export const HR_APPLICATION_APPROVED_STATUS = 'approved';

export const INITIAL_QUICK_QUOTE = {
  leaseTerm: undefined,
  kmsPerYear: undefined,
  costs: {
    fuel: undefined,
    maintenance: undefined,
    tyres: undefined,
    registration: undefined,
    insurance: undefined,
  },
  novated: {
    salarySacrificePayment: undefined,
    notSalarySacrificePayment: undefined,
    novatedSaving: undefined,
    totalTaxSaving: undefined,
    taxSaving: undefined,
    gstSavingBudget: undefined,
    gstSavingVehicle: undefined,
    salarySacrificeTakeHomePay: undefined,
    notSalarySacrificeTakeHomePay: undefined,
    salarySacrificeImpactTakeHome: undefined,
    notSalarySacrificeImpactTakeHome: undefined,
  },
  calculation: [],
  takeHome: {
    sacrifice: undefined,
    noSacrifice: undefined,
  },
};

export const UPLOAD_QUOTE_MIN_CAR_COST = {
  [NEW_USED_LIST.new.value]: 0,
  [NEW_USED_LIST.used.value]: 7500,
};
export const REGISTRATION_NUMBER_MAX_LENGTH = 50;
export const MIN_ODOMETER = 0;
export const MAX_ODOMETER = 999999999;
export const MAX_CAR_PRICE = 9999999;
export const MAX_ALLOWED_TERM_KMS = 200000; // as capped by ERP-Drive

export const EXTERIOR_COLOUR_MAX_LENGTH = 30;
export const INTERIOR_COLOUR_MAX_LENGTH = 30;
export const ADHOC_EQUIPMENT_MAX_LENGTH = 50;
export const TEMP_ADHOC_EQUIPMENT_MAX_LENGTH = 50;
